import{createContext as l}from"react";const o=l(null),r=l(null);export{r as SwiperContext,o as SwiperSlideContext};
//# sourceMappingURL=context.js.map
